import { render } from "./ResellYourTicket.vue?vue&type=template&id=fdf4034e&scoped=true&ts=true"
import script from "./ResellYourTicket.vue?vue&type=script&lang=ts"
export * from "./ResellYourTicket.vue?vue&type=script&lang=ts"

import "./ResellYourTicket.vue?vue&type=style&index=0&id=fdf4034e&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf4034e"]])

export default __exports__